import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a6afbf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_career_contents_wrapper" }
const _hoisted_2 = { class: "entry_career_indicator" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "entry_career_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_career_title_text" }, "ご連絡先を"),
  /*#__PURE__*/_createElementVNode("span", { class: "entry_career_title_text" }, "教えてください")
], -1))
const _hoisted_4 = { class: "entry_career_input" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "携帯電話番号"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_6 = { class: "entry_career_input_layout_column_1" }
const _hoisted_7 = { class: "entry_career_input_layout_column_1_item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "entry_career_cellular_annotation" }, "半角数字のみ、ハイフンなしでご入力ください", -1))
const _hoisted_9 = { class: "entry_career_input" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "郵便番号と住所"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_11 = {
  key: 0,
  class: "entry_career_input_postcode"
}
const _hoisted_12 = { class: "entry_career_input_pref" }
const _hoisted_13 = { class: "entry_career_input_layout_column_2" }
const _hoisted_14 = { class: "entry_career_input_layout_column_2_item" }
const _hoisted_15 = { class: "entry_career_input_layout_column_2_item" }
const _hoisted_16 = { class: "entry_career_input_layout_column_1" }
const _hoisted_17 = { class: "entry_career_input_layout_column_1_item" }
const _hoisted_18 = { class: "entry_career_input_layout_column_1_item" }
const _hoisted_19 = { class: "entry_career_button" }
const _hoisted_20 = { class: "entry_career_button_prev" }
const _hoisted_21 = { class: "entry_career_button_next" }

import { ref, computed, watchEffect } from 'vue';
import { useRouter } from 'vue-router';
import { useField, useForm } from 'vee-validate';
import { object, string } from 'yup';
import Indicator from '@/components/Indicator.vue';
import BaseSelectBox, { Options } from '@/components/BaseSelectBox.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseTextForm from '@/components/BaseTextForm.vue';
import PostCodeForm from '@/components/PostCodeForm.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import Loading from '@/components/Loading.vue';
import VALIDATON_ERRORS from '@/constants/validationErrors';
import { getMasterDataListPref, getMasterDataPostCode } from '@/api/masterDataEndpoint';
import { getContactInfo, postContactInfo } from '@/api/careersheetEndpoint';
import store from '@/store';
import { RadioListType } from '@/types';
import SelectRadioModal from '@/components/SelectRadioModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddressView',
  setup(__props) {

const prefListConvert = ref<Options>([]);
const isLoading = ref(false);

const init = async () => {
  isLoading.value = true;
  try {
    const [resContactInfo, mstPrefList] = await Promise.all([getContactInfo(), getMasterDataListPref()]);
    prefListConvert.value = mstPrefList.map((i) => {
      return { value: i.code, label: i.name };
    });
    telCellular.value = resContactInfo.telCellular || '';
    zipCode.value = resContactInfo.zipCode || '';
    prefId.value = resContactInfo.prefId || '';
    addr1.value = resContactInfo.addr1 || '';
    addr2.value = resContactInfo.addr2 || '';
    addr3.value = resContactInfo.addr3 || '';
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};
init();

const schema = object({
  telCellular: string()
    .label('携帯電話番号')
    .required(VALIDATON_ERRORS.REQUIRED)
    .length(11, VALIDATON_ERRORS.TEL_CELLULAR_LENGTH)
    .matches(/^\d*$/, VALIDATON_ERRORS.NUMERIC),
  zipCode: string()
    .label('郵便番号')
    .required(VALIDATON_ERRORS.REQUIRED)
    .min(7, VALIDATON_ERRORS.ZIPCODE_LENGTH)
    .matches(/^\d*$/, VALIDATON_ERRORS.NUMERIC),
  prefId: string().label('都道府県').required(VALIDATON_ERRORS.REQUIRED),
  addr1: string().label('市区町村').required(VALIDATON_ERRORS.REQUIRED),
  addr2: string().nullable().label('町名・丁目・番地・号').required(VALIDATON_ERRORS.REQUIRED),
  addr3: string(),
});
const { meta, errors } = useForm({
  validationSchema: schema,
});

const { value: telCellular } = useField('telCellular', undefined, {
  initialValue: '',
});
const { value: zipCode } = useField('zipCode', undefined, {
  initialValue: '',
});
const { value: prefId } = useField('prefId', undefined, {
  initialValue: '',
});
const { value: addr1 } = useField('addr1', undefined, {
  initialValue: '',
});
const { value: addr2 } = useField('addr2', undefined, {
  initialValue: '',
});
const { value: addr3 } = useField('addr3', undefined, {
  initialValue: '',
});
const addressesErrors = computed(() => {
  const err = [];
  if (errors.value.prefId) {
    err.push(errors.value.prefId);
  }
  if (errors.value.addr1) {
    err.push(errors.value.addr1);
  }
  if (errors.value.addr2) {
    err.push(errors.value.addr2);
  }
  return err;
});

const searchAddress = async (postCode: string) => {
  // 入力された郵便番号より住所情報を取得
  await Promise.all([
      store.dispatch('master/getMasterDataPostCode', { postCode }),
  ]);
  const postCodeList = store.getters['master/postCodeList'];

  if (postCodeList.length === 1) {
    prefId.value = String(postCodeList[0].prefId);
    addr1.value = postCodeList[0].cityName;
    addr2.value = postCodeList[0].blockName;
  } else if (postCodeList.length > 1) {
    openPostCodeModal();
  } else {
    console.error('not found');
    return;
  }
};

const router = useRouter();
const transitionPreviousPage = () => {
  router.push({ name: 'b08' });
};

const submit = async () => {
  isLoading.value = true;

  try {
    await postContactInfo({
      telCellular: telCellular.value,
      zipCode: zipCode.value,
      prefId: Number(prefId.value),
      addr1: addr1.value,
      addr2: addr2.value,
      addr3: addr3.value,
    });
    router.push({ name: 'c01' });
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

const zipId = ref();
const postCodeFlat: ref<{ [key: number]: string }> = computed(() => {
  return store.getters['master/postCode'];
});
const postCodeList: ref<RadioListType[]> = computed(() => {
  return store.getters['master/postCodeRadioList'];
});

// 住所情報の更新
watchEffect(() => {
  if (zipId.value !== undefined) {
    const postCode = postCodeFlat.value[zipId.value];
    prefId.value = zipId.value === null ? '' : postCode.get('prefId') || '';
    addr1.value = zipId.value === null ? '' : postCode.get('cityName') || '';
    addr2.value = zipId.value === null ? '' : postCode.get('blockName') || '';
  };
});

const shownPostCodeModal = ref(false);
const openPostCodeModal = () => {
  shownPostCodeModal.value = true;
};
const closePostCodeModal = () => {
  shownPostCodeModal.value = false;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Indicator, {
          current: 1,
          max: 12
        })
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(BaseTextForm, {
              modelValue: _unref(telCellular),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(telCellular) ? (telCellular).value = $event : null)),
              type: "tel",
              placeholder: "09012345678",
              isError: !!_unref(errors).telCellular
            }, null, 8, ["modelValue", "isError"]),
            (_unref(errors).telCellular)
              ? (_openBlock(), _createBlock(ErrorMessage, {
                  key: 0,
                  errors: [_unref(errors).telCellular]
                }, null, 8, ["errors"]))
              : _createCommentVNode("", true),
            _hoisted_8
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        (!isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(PostCodeForm, {
                modelValue: _unref(zipCode),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(zipCode) ? (zipCode).value = $event : null)),
                onClick: searchAddress,
                isError: !!_unref(errors).zipCode
              }, null, 8, ["modelValue", "isError"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(BaseSelectBox, {
                modelValue: _unref(prefId),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(prefId) ? (prefId).value = $event : null)),
                options: prefListConvert.value,
                hasCancelButton: "",
                placeholder: "都道府県を選択",
                isError: !!_unref(errors).prefId
              }, null, 8, ["modelValue", "options", "isError"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(BaseTextForm, {
                modelValue: _unref(addr1),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(addr1) ? (addr1).value = $event : null)),
                maxlength: 50,
                placeholder: "市区郡町村",
                isError: !!_unref(errors).addr1
              }, null, 8, ["modelValue", "isError"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(BaseTextForm, {
              modelValue: _unref(addr2),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(addr2) ? (addr2).value = $event : null)),
              maxlength: 70,
              placeholder: "町名・丁目・番地・号",
              isError: !!_unref(errors).addr2
            }, null, 8, ["modelValue", "isError"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(BaseTextForm, {
              modelValue: _unref(addr3),
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(addr3) ? (addr3).value = $event : null)),
              maxlength: 70,
              placeholder: "建物・マンション名",
              isError: !!_unref(errors).addr3
            }, null, 8, ["modelValue", "isError"])
          ])
        ])
      ]),
      (_unref(errors).zipCode)
        ? (_openBlock(), _createBlock(ErrorMessage, {
            key: 0,
            errors: [_unref(errors).zipCode]
          }, null, 8, ["errors"]))
        : _createCommentVNode("", true),
      _createVNode(ErrorMessage, { errors: _unref(addressesErrors) }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(BaseButton, {
            onClick: transitionPreviousPage,
            theme: "tertiary",
            type: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(BaseButton, {
            onClick: submit,
            theme: "primary",
            type: "button",
            disabled: _unref(meta).valid && _unref(meta).dirty ? false : true
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 保存して次へ ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    (shownPostCodeModal.value)
      ? (_openBlock(), _createBlock(SelectRadioModal, {
          key: 0,
          title: "住所選択",
          modelValue: zipId.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((zipId).value = $event)),
          list: _unref(postCodeList),
          onClose: closePostCodeModal
        }, null, 8, ["modelValue", "list"]))
      : _createCommentVNode("", true)
  ]))
}
}

})